import { render, staticRenderFns } from "./video.vue?vue&type=template&id=46c648a7&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=46c648a7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c648a7",
  null
  
)

export default component.exports